import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Domicilio`
const API_ENDPOINT_V2 = `${CONS.API_ENDPOINT_BACK_NODE}/domicilios`

export function buscarTodas(idUsuario, tipoUsuario) {
  return http.get(`${API_ENDPOINT}/BuscarDomicilio/${idUsuario}/${tipoUsuario}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los domicilios.',
      tipoError: 'domicilio'
    }
  })
}

export function insertar(domicilio) {
  return http.post(API_ENDPOINT, domicilio)
}

export function eliminarDomicilio(idUsuarioDomicilio) {
  return http.delete(`${API_ENDPOINT}/EliminarDomicilio/${idUsuarioDomicilio}`)
}

export function actualizarDomicilio(domicilio) {
  return http.put(API_ENDPOINT, domicilio)
}

export function BuscarPorPais(idPais) {
  return http.get(`${API_ENDPOINT}/BuscarPorPais/${idPais}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los domicilios.',
      tipoError: 'domicilio'
    }
  })
}

export function BuscarLocalidades(idProvincia) {
  return http.get(`${API_ENDPOINT}/BuscarLocalidades/${idProvincia}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los domicilios.',
      tipoError: 'domicilio'
    }
  })
}

export function guardarPreferidos(idUsuario, idUsuarioDomicilio, vieneDeCompras = false) {
  const idUsuarioDomicilios = Array.isArray(idUsuarioDomicilio)
    ? idUsuarioDomicilio.map((id) => String(id))
    : [String(idUsuarioDomicilio)]

  return http.post(
    `${API_ENDPOINT}/GuardarPreferidos`,
    { idUsuario, idUsuarioDomicilio: idUsuarioDomicilios, vieneDeCompras },
    {
      meta: {
        toastMessage: 'Ocurrió un error al guardar los domicilios preferidos.',
        tipoError: 'domicilio'
      }
    }
  )
}

export function buscarDomicilioPrincipal(body) {
  return http.post(`${API_ENDPOINT_V2}/obtenerDomicilioPrincipal`, body, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los domicilios.',
      tipoError: 'domicilio'
    }
  })
}
